const policy_invoice_statuses = [
  {
    label: "Draft",
    value: "draft",
  },
  {
    label: "Open",
    value: "open",
  },
  {
    label: "Paid",
    value: "paid",
  },
  {
    label: "Void",
    value: "void",
  },
  {
    label: "Uncollectible",
    value: "uncollectible",
  },
];

export default policy_invoice_statuses;
